/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';
import { usePathname } from 'next/navigation';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import { usePageType } from '@hooks/usePageType';

import { gtmObject } from '@ieo/Components/Form/ieo/api/analyticsAPi';
import { useProgramLanguageSelection } from '@ieo/Components/Form/ieo/context/programLanguageSelectionContext';
import { programTypes } from '@ieo/Components/Form/ieo/utils';

/* Service */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';
// import ProgramFeeSt from './ProgramFeeSt';
import { createSectionContentMap } from '../../components/Utility/Shared/SharedService';
import ProgramFeeSt from '../ieo/Common/StyleData/ProgramFeeSt';

/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const ProgramFee = ({
  sectionContent,
  region,
  lang,
  prgData,
  pageData,
  scholarshipsRef,
  isInPerson = false,
}) => {
  // const toast = useToast();

  const [isOpen1, setIsOpen1] = useState(false);
  const [couponCopied, setCouponCopied] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const priceData = Object.values(prgData);
  // console.log(priceData, 'pricedata');
  const [isGiftingFlow, setIsGiftingFlow] = useState();
  const { setProgramLanguage, programLanguage } = useProgramLanguageSelection();
  const url = usePathname();
  const isPcPage = url.split('/').includes('inner-engineering-pc');
  const transProviderObj =
    (pageData._allSharedJsonLocales?.length &&
      pageData._allSharedJsonLocales[0]?.value.json) ||
    pageData.sharedJson?.json;
  const { isGiftPage } = usePageType();
  const additionalText = sectionContent?.find(
    e => e.fieldId === 'additional-off'
  );

  const additionalTextVernacular = sectionContent?.find(
    e => e.fieldId === 'additional-off-vernacular'
  );

  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  const untilText = sectionContent?.find(e => e.fieldId === 'offer-until');
  const router = useRouter();
  const isLandingOrPcPage =
    region === 'in' &&
    (router.asPath?.split('?')[0].endsWith('inner-engineering-pc') ||
      router.asPath?.split('?')[0].endsWith('inner-engineering'));

  // const isUS = pageData?.country === 'US';
  // const isCA = pageData?.country === 'CA';
  // console.log('sectionContent===>', sectionContent);

  const gtmClick = (lang, price) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window?.dataLayer?.push({
        event: 'IE_Language_Selected',
        IE_Lang: lang,
        IE_LP_Location: 'Language_Table',
      });

      window?.dataLayer?.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window?.dataLayer?.push({
        event: 'add_to_wishlist',
        ecommerce: {
          currency: 'INR', // currency code (Ex - INR,USD,AUD etc.)
          value: price || priceData[0]?.discountedPrice || '',
          items: [
            {
              item_id: programTypes.IEO, // id of the program
              item_name: isGiftPage
                ? 'Gift Inner Engineering'
                : 'TYLS Inner Engineering', // Name of the program (Ex - TYLS Inner Engineering)
              affiliation: '',
              coupon: '',
              discount: 0, //Actual Discount if any (actual price - pay price)
              index: '',
              item_brand: '', // Country Code (Ex - US,IN etc.)
              item_category: '', // Language (Ex - English,Spanish etc.)
              item_category2: '', // Bay Name (not reuired for IE)
              item_category3: '', // New_User or Repeat_User
              item_category4: 'Language_Table',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: price || priceData[0]?.discountedPrice || '',
              quantity: '',
            },
          ],
        },
      });

      gtmObject({
        event: isGiftPage ? 'IE_Gift_Inner_Engineering' : 'IE_Register_Now',
        IE_LP_Location: 'Sticky_CTA',
        event1: 'view_item',
        item_name: isGiftPage
          ? 'Gift Inner Engineering'
          : 'TYLS Inner Engineering',
        item_category4: 'Language_Table',
      });
    }
  };
  let PriceDataList = [];
  if (region === 'in') {
    config.orderedLangList[lang].forEach(language => {
      const price = priceData.filter(item => {
        return item.lang === language.toUpperCase();
      });
      if (price.length > 0) {
        PriceDataList.push(price[0]);
      }
    });
  } else {
    PriceDataList = [...priceData];
  }
  const isIndian = region === 'in';
  // const changeUi = !isIndian;
  const changeUi =
    router.asPath.indexOf('inner-engineering-pc') > 0 && isIndian;
  const [discountText, setDiscountText] = useState({});

  useEffect(() => {
    if (priceData?.length) {
      // console.log('priceData', priceData, pageConfigVal, pageData?.pageConfig);
      let filteredText =
        isThemeActive &&
        filter(pageConfigVal?.discounText, function (item) {
          return (
            item.code === priceData[0].coupon?.couponCode &&
            item.lang?.toLowerCase() === lang.toLowerCase()
          );
        });
      if (filteredText?.length) {
        setDiscountText(filteredText[0]);
      }
      if (router.asPath.indexOf('theo-von-podcast-listeners') > 0) {
        priceData[0].pgmFee = ' 175';
        priceData[0].discountedPrice = ' 88';
      }
    }
  }, [priceData]);

  useEffect(() => {
    if (router.asPath.indexOf('/gift') > -1) {
      setIsGiftingFlow(true);
    }
  }, [router.asPath]);

  // const copyStyle = {
  //   Normal: {
  //     background: '#F1EBDF78',
  //     color: '#5b5237',
  //   },
  //   Selected: {
  //     background: '#E86F34',
  //     color: '#FFFFFF',
  //   },
  // };
  const clickCopyCode = code => {
    copy(code);
    setCouponCopied(true);
    setTimeout(function () {
      setCouponCopied(false);
    }, 1000);
  };

  const sectionContentMap = createSectionContentMap(sectionContent);
  // FieldId mapper for robust data access
  const fieldIdMapper = {
    inPerson: {
      title: 'section_title',
      body1: 'inperson-program-fee-body1',
      body2: 'inperson-program-fee-body2',
      discountBody: 'inperson-discount-body',
      couponCode: 'inperson-coupon-code',
      regionalLanguages: 'inperson-regional-languages',
      table: 'inperson-program-fee-table',
      button: 'program-fee-button',
    },
    online: {
      title: 'section_title',
      body1: 'online-program-fee-body1',
      body2: 'online-program-fee-body2',
      discountBody: 'online-discount-body',
      couponCode: 'online-coupon-code',
      regionalLanguages: 'online-regional-languages',
      table: 'online-program-fee-table',
      button: 'program-fee-button',
    },
  };

  const currentMapper = isInPerson
    ? fieldIdMapper.inPerson
    : fieldIdMapper.online;

  const isLatamCoutries = () => {
    return (
      pageData?.country &&
      config?.latinAmericaCountries?.indexOf(pageData?.country) > -1
    );
  };

  const currentSelectedLangPrice = useMemo(() => {
    if (!programLanguage) return priceData[0];
    let priceValue = priceData?.find(
      e => e?.lang?.toLowerCase() === programLanguage?.toLowerCase()
    );
    if (!priceValue) {
      priceValue = priceData[0];
    }
    return priceValue;
  }, [priceData, programLanguage]);

  return (
    <Box
      bg={
        isThemeActive && pageConfigVal?.prgFees?.bgImage?.desktop
          ? `url(${pageConfigVal?.prgFees?.bgImage?.desktop})`
          : `url(https://static.sadhguru.org/d/46272/1694863180-program-fee.png)`
      }
      bgRepeat="no-repeat"
      bgSize="cover"
      bgColor="#00005B"
    >
      <Flex
        maxW={1030}
        bgRepeat="no-repeat"
        pt={{ base: 10, md: 'unset' }}
        px={{ base: 4, lg: 2, xl: 0 }}
        id="ieo-program-fees"
        mx="auto"
        // mt={{ base: '0px', md: '-140px' }}
        // p={10}
      >
        <Flex
          w="full"
          mx="auto"
          flexWrap="wrap"
          // px={{ base: changeUi ? '0' : '16px', xl: 0 }}
          px={{ base: 2, md: 4 }}
          pt={{
            base: '0px',
            md: lang === 'ar' ? '30px' : '40px',
            xl: '40px',
          }}
        >
          <Flex
            w="full"
            px={{ base: changeUi ? '16px' : '0', xl: 0 }}
            flexDir={{ base: 'column', lg: 'row' }}
            justifyContent="space-between"
            alignItems={changeUi && { base: 'flex-start', lg: 'center' }} // just remove for the older ui
            gridGap={{ base: '30px', md: '80px', '2xl': '70px' }}
            css={{
              '-webkit-grid-gap': '40px',
              '@media screen and (min-width: 768px)': {
                '-webkit-grid-gap': '80px',
              },
            }}
            pb="40px"
          >
            <Box
              color="#fff"
              w={{
                base: '100%',
                md: '60%',
                lg: '80%',
                // xl:
                //   isThemeActive && pageConfigVal?.prgFees?.offerBg?.desktop
                //     ? '65%'
                //     : '60%',
                // '2xl':
                //   isThemeActive && pageConfigVal?.prgFees?.offerBg?.desktop
                //     ? '65%'
                //     : '60%',
              }}
              display="flex"
              justifyContent="flex-start"
              flexDirection="column"
              // alignItems={lang === 'ar' ? 'flex-end' : 'flex-start'}
            >
              <Heading
                as="h2"
                {...ProgramFeeSt[lang].h2_us_in_person}
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
                whiteSpace={{ base: 'normal', lg: 'nowrap' }}
              >
                {sectionContentMap['section_title']?.titleText}
              </Heading>
              {/* //Info : This program is also available in  */}
              <Box maxW={'300px'}>
                <StructuredTextParser
                  mt="15px"
                  str={render(
                    sectionContentMap['ieo-online-program-fees-sub-heading']
                      ?.body
                  )}
                  {...ProgramFeeSt[lang].usInPersonP1}
                  maxW="auto"
                  color="#fff"
                  dir={lang == 'ar' ? 'rtl' : 'ltr'}
                />
              </Box>
              <StructuredTextParser
                mt="15px"
                str={render(
                  sectionContentMap['ieo-online-program-fees-text']?.body
                )}
                {...ProgramFeeSt[lang].usInPersonP2}
                maxW="auto"
                dir={lang == 'ar' ? 'rtl' : 'ltr'}
              />

              {region !== 'in' &&
                transProviderObj?.globalLanguages &&
                !isGiftingFlow &&
                !isInPerson && (
                  <Box position="relative" mt="20px">
                    <Button
                      py={{ base: 8, md: 8 }}
                      px={{ base: '16px', md: '20px' }}
                      flex="1"
                      bg="#CE6113"
                      border="none"
                      color="#fff"
                      w={{ base: '100%', sm: 'auto' }}
                      maxW={{ xl: '297px' }}
                      minW={{ md: '275px' }}
                      h={{ base: '38px', md: '46px' }}
                      rounded="full"
                      position="relative"
                      zIndex={88}
                      justifyContent="space-between"
                      _hover={{ border: 'none' }}
                      _focus={{ border: 'none' }}
                      _active={{ border: 'none' }}
                      // rightIcon={isOpen ? <TbChevronUp /> : <TbChevronDown />}
                      onClick={() => setIsOpen1(!isOpen1)}
                      // textTransform="capitalize"
                      {...ProgramFeeSt[lang].selectLang}
                    >
                      {' '}
                      <Flex
                        w="100%"
                        justifyContent="space-between"
                        alignItems="center"
                        gap="10px"
                      >
                        <Box flexShrink={0}>
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.36036 13.8267H11.167C11.4537 14.4867 12.1004 15.8 13.1337 17.0733C12.3404 17.8467 11.367 18.4933 10.227 18.74C9.86703 18.82 9.64036 19.1733 9.72036 19.5333C9.78703 19.8467 10.067 20.06 10.3737 20.06C10.4204 20.06 10.467 20.0533 10.5137 20.0467C11.927 19.74 13.0937 18.9733 14.0404 18.06C14.987 18.9667 16.1537 19.7333 17.567 20.0467C17.6137 20.06 17.6604 20.06 17.707 20.06C18.0137 20.06 18.287 19.8467 18.3604 19.5333C18.4404 19.1733 18.2137 18.82 17.8537 18.74C16.707 18.4933 15.7404 17.8467 14.947 17.0733C15.9804 15.8 16.6204 14.4933 16.9137 13.8267H18.7204C19.087 13.8267 19.387 13.5267 19.387 13.16C19.387 12.7933 19.087 12.4933 18.7204 12.4933H14.7137V11.1667C14.7137 10.8 14.4137 10.5 14.047 10.5C13.6804 10.5 13.3804 10.8 13.3804 11.1667V12.4933H9.3737C9.00703 12.4933 8.70703 12.7933 8.70703 13.16C8.70703 13.5267 8.9937 13.8267 9.36036 13.8267ZM14.0337 16.06C13.4004 15.2467 12.9404 14.4267 12.6404 13.8267H15.427C15.127 14.4333 14.6604 15.2533 14.0337 16.06Z"
                              fill="white"
                            />
                            <path
                              d="M25.4341 27.1661C25.7741 27.3061 26.1607 27.1461 26.3074 26.8061L27.1141 24.8728H30.6541L31.4607 26.8061C31.5674 27.0594 31.8141 27.2128 32.0741 27.2128C32.1607 27.2128 32.2474 27.1928 32.3341 27.1594C32.6741 27.0194 32.8341 26.6261 32.6941 26.2861L31.7141 23.9461C31.7141 23.9461 31.7141 23.9394 31.7074 23.9394L29.4941 18.6528C29.3874 18.4061 29.1474 18.2461 28.8807 18.2461C28.6141 18.2461 28.3674 18.4061 28.2674 18.6528L26.0541 23.9461L25.0741 26.2861C24.9341 26.6328 25.0941 27.0261 25.4341 27.1661ZM28.8807 20.6461L30.0941 23.5461H27.6674L28.8807 20.6461Z"
                              fill="white"
                            />
                            <path
                              d="M6.51398 23.8994H6.98065V26.926C6.98065 27.1927 7.14065 27.4394 7.39398 27.5394C7.47398 27.5727 7.56065 27.5927 7.64732 27.5927C7.82065 27.5927 7.99398 27.526 8.12065 27.3994L11.614 23.906H18.0007V27.4394C18.0007 29.006 19.274 30.2794 20.8407 30.2794H29.3873L32.3806 33.2727C32.5073 33.3994 32.6806 33.466 32.854 33.466C32.9406 33.466 33.0273 33.4527 33.1073 33.4127C33.354 33.3127 33.5206 33.066 33.5206 32.7994V30.2794H33.8273C35.394 30.2794 36.6673 29.006 36.6673 27.4394V18.0394C36.6673 16.4727 35.394 15.1994 33.8273 15.1994H24.734V9.84604C24.734 8.09271 23.3073 6.66604 21.554 6.66604H6.51398C4.76065 6.65937 3.33398 8.08604 3.33398 9.83937V20.7194C3.33398 22.4727 4.76065 23.8994 6.51398 23.8994ZM33.8273 16.526C34.6607 16.526 35.334 17.1994 35.334 18.0327V27.4327C35.334 28.266 34.6607 28.9394 33.8273 28.9394H32.854C32.4873 28.9394 32.1873 29.2394 32.1873 29.606V31.186L30.134 29.1327C30.0073 29.006 29.8407 28.9394 29.6607 28.9394H20.8407C20.0073 28.9394 19.334 28.266 19.334 27.4327V23.8994H21.554C23.3073 23.8994 24.734 22.4727 24.734 20.7194V16.526H33.8273ZM4.66732 9.83937C4.66732 8.81937 5.49398 7.99271 6.51398 7.99271H21.5473C22.5673 7.99271 23.394 8.81937 23.394 9.83937V20.7194C23.394 21.7394 22.5673 22.566 21.5473 22.566H11.334C11.154 22.566 10.9873 22.6394 10.8607 22.7594L8.30732 25.3127V23.2327C8.30732 22.866 8.00732 22.566 7.64065 22.566H6.50732C5.49398 22.566 4.66732 21.7394 4.66732 20.7194V9.83937Z"
                              fill="white"
                            />
                          </svg>
                        </Box>
                        <Text
                          flex={1}
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          display="flex"
                          gridGap="10px"
                          alignItems="center"
                          fontWeight={'500'}
                        >
                          {transProviderObj?.formFields?.selectLanguage.replace(
                            'Language',
                            'language'
                          )}
                        </Text>
                        <Box flexShrink={0}>
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M30 13.5002L18 25.5002L6 13.5002"
                              stroke="white"
                              strokeWidth="2.25"
                              strokeLinecap="square"
                            />
                          </svg>
                        </Box>
                      </Flex>
                    </Button>

                    {isOpen1 && (
                      <Flex
                        _before={{ content: "''", height: '17px' }}
                        _after={{ content: "''", height: '17px' }}
                        display={isOpen1 ? 'block' : 'none'}
                        _hover={{ display: 'block' }}
                        className="options"
                        zIndex="9"
                        alignItems="flex-start"
                        alignContent="flex-start"
                        onClick={() => setIsOpen1(!isOpen1)}
                        position="absolute"
                        top={{ base: '25px', md: '18px' }}
                        border="1px solid #EDD1C2"
                        left="0"
                        borderRadius="0 0 14px 14px"
                        w={{ base: '100%', sm: 'auto' }}
                        minW={{ base: '250px', md: '275px' }}
                        flexDir="column"
                        bg="#ffffff"
                        mt={{ base: '0', md: '8px' }}
                        p="30px 17px 0 17px"
                      >
                        <Box padding="8px 0" cursor="pointer">
                          {Object.keys(transProviderObj?.globalLanguages)?.map(
                            (language, index) => {
                              return (
                                <Box
                                  padding="8px 0"
                                  key={nanoid()}
                                  cursor="pointer"
                                  onClick={() => {
                                    setProgramLanguage(language.toUpperCase());
                                    gtmClick(language.toUpperCase());
                                  }}
                                >
                                  <Text
                                    {...ProgramFeeSt[lang].selectLangDrowDown}
                                    color="#6D6358"
                                    textAlign="left"
                                    _hover={{ color: '#CE6113' }}
                                    dir={lang == 'ar' ? 'rtl' : 'ltr'}
                                  >
                                    {
                                      transProviderObj?.globalLanguages[
                                        language
                                      ]
                                    }
                                  </Text>
                                </Box>
                              );
                            }
                          )}
                        </Box>
                      </Flex>
                    )}
                  </Box>
                )}
            </Box>

            {/* //the program fee card in inperson tab is coming from this block */}
            {(isLatamCoutries() ||
              pageData?.country === 'US' ||
              pageData?.country === 'CA') &&
            priceData[0]?.coupon?.couponCode &&
            isThemeActive &&
            1 !== 1 &&
            pageConfigVal?.prgFees ? (
              <Flex
                // bg={`url(${pageConfigVal?.prgFees?.offerBg?.desktop})`}
                bg="#fff !important"
                bgRepeat="no-repeat"
                bgSize="cover"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '20px', md: '70px' }}
                flexDir="column"
                position="relative"
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <svg
                      stroke="#be1931"
                      fill="#be1931"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      height="2.5em"
                      width="2.5em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                    </svg>
                  </Flex>
                  {/* <StructuredTextParser
                    mt="0px"
                    str={render(sectionContent?.[3].body)}
                    {...ProgramFeeSt[lang].feeDiscount1}
                    maxW="auto"
                    color="#6D6358"
                    fontSize={{ base: '16px', md: '18px' }}
                    dir={lang == 'ar' ? 'rtl' : 'ltr'}
                  /> */}
                </Flex>
                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}
                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                    pb={{ base: '20px', md: '20px' }}
                  >
                    <StructuredTextParser
                      str={`${priceData[0]?.curr} ${priceData[0]?.pgmFee}`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      fontSize={{ base: '24px', md: '26px' }}
                    />

                    <StructuredTextParser
                      str={`${priceData[0]?.curr} ${priceData[0]?.discountedPrice}`}
                      maxW="none"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      fontSize={{ base: '28px', md: '36px' }}
                    />
                    <Box
                      fontSize={{ base: '26px', md: '28px' }}
                      color="#6D6358"
                      fontFamily="'FedraSansStd-medium'"
                      pb="0px"
                      textAlign="center"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      pt={{ base: '15px', md: '20px' }}
                    >
                      {discountText?.text}
                    </Box>
                    {priceData && (
                      <Box
                        fontSize={{ base: '16px', md: '18px' }}
                        fontFamily="'FedraSansStd-book'"
                      >
                        <StructuredTextParser
                          str={render(additionalText?.body)
                            ?.replace('#num#', priceData[0]?.coupon?.offerValue)
                            .replace(
                              '##COUPONCODE##',
                              priceData[0]?.coupon?.couponCode
                            )
                            .replace('##CURRENCY##', priceData[0]?.curr)
                            .replace(
                              '##PRICE##',
                              priceData[0]?.coupon?.offerValue
                            )}
                          color="#A69786"
                          fontFamily="'FedraSansStd-book'"
                          dir={lang == 'ar' ? 'rtl' : 'ltr'}
                        />
                      </Box>
                    )}
                    <Box
                      fontSize={{ base: '32px', md: '50px' }}
                      color="#CD9F00"
                      fontFamily="'FedraSansStd-medium'"
                      lineHeight="46px"
                    >
                      {priceData[0]?.curr}{' '}
                      {priceData[0]?.coupon?.postCouponPrice}
                    </Box>
                    <Box
                      bgColor={
                        couponCopied ? '#E86F34 !important' : '#F1EBDF78'
                      }
                      py="5px"
                      px="15px"
                      mt="25px"
                      w="157px"
                      cursor="pointer"
                      _hover={{
                        bgColor: '#FAE4B8',
                      }}
                      onClick={() => {
                        clickCopyCode(
                          priceData[0]?.coupon?.couponCode ||
                            sectionContent?.[8]?.text //not fetching anything
                        );
                      }}
                    >
                      <Box
                        fontSize={{ base: '16px', md: '18px' }}
                        fontFamily="'FedraSansStd-medium'"
                        color={couponCopied ? '#FFFFFF' : '#5B5237'}
                        display="flex"
                        alignItems="center"
                        gap="10px"
                      >
                        {/* not fetching anything */}
                        {priceData[0]?.coupon?.couponCode ||
                          sectionContent?.[8]?.text}

                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.0938 15.9688V18.5938H4.15625V5.03125H6.78125M13.3438 2.40625H6.78125V15.9688H17.7188V6.78125M13.3438 2.40625L17.7188 6.78125M13.3438 2.40625V6.78125H17.7188"
                            stroke={couponCopied ? '#FFFFFF' : '#F37021'}
                            strokeWidth="1.625"
                            strokeLinecap="square"
                          />
                        </svg>
                      </Box>
                    </Box>

                    {/* {!isLandingOrPcPage && ( // TODO check this condition */}
                    <Flex
                      fontSize="14px"
                      color="#F37021"
                      fontFamily="'FedraSansStd-book'"
                      fontWeight="600"
                      paddingLeft="5px"
                    >
                      <StructuredTextParser
                        str={render(sectionContentMap['offer-until']?.body)}
                        color="#F37021"
                        fontSize="14px"
                        dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      />
                      {/* <Box mt="15px" ml="5px">
                          {moment(priceData[0]?.coupon?.expiryDate).format(
                            'Do MMMM YYYY'
                          )}
                        </Box> */}
                    </Flex>
                    {/* )} */}
                  </Flex>
                )}
              </Flex>
            ) : priceData[0]?.coupon?.couponCode &&
              isThemeActive &&
              pageConfigVal?.prgFees ? (
              <Flex
                bg={`url(${pageConfigVal?.prgFees?.offerBg?.desktop})`}
                bgRepeat="no-repeat"
                bgSize="cover"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '20px', md: '70px' }}
                flexDir="column"
                position="relative"
                maxW={{ base: 'auto', md: '540px' }}
                w="full"
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.7985 17.5208L34.7477 15.8735L31.1611 15.9836L32.7744 13.985L31.4914 12.9517L28.9888 16.0514L24.6611 16.1827L28.4044 11.5459L27.5448 10.1527L21.7266 11.4315L23.7761 7.61624L27.6676 6.76087L27.3162 5.15176L24.8051 5.70224L26.5031 2.5433L25.0507 1.76414L23.3527 4.92309L22.4295 2.52636L20.8924 3.11919L22.3237 6.83709L20.2742 10.6524L18.1315 5.09247L16.497 5.14329L14.6931 10.8218L12.4149 7.13774L13.6217 3.33938L12.0507 2.83971L11.2758 5.28726L9.38723 2.23418L7.9856 3.10225L9.8742 6.15534L7.33772 5.75729L7.08365 7.38758L11.0175 8.00582L13.2957 11.6898L7.40971 10.7667L6.63479 12.2065L10.6491 16.6061L6.32144 16.7374L3.63676 13.7944L2.41722 14.9038L4.14913 16.8009L0.5625 16.911L0.613314 18.5582L4.19995 18.4481L2.5866 20.4468L3.86966 21.48L6.37225 18.3804L10.6999 18.2491L6.95662 22.8859L7.81622 24.2791L13.6344 23.0002L11.5849 26.8155L7.69342 27.6709L8.04489 29.28L10.5517 28.7295L8.85368 31.8885L10.3061 32.6676L12.0042 29.5087L12.9273 31.9054L14.4644 31.3126L13.0331 27.5947L15.0826 23.7794L17.2253 29.3393L18.8598 29.2885L20.6637 23.61L22.9419 27.294L21.7351 31.0924L23.3061 31.5921L24.0852 29.1445L25.9738 32.1976L27.3754 31.3295L25.4868 28.2764L28.0233 28.6745L28.2774 27.0484L24.3435 26.4302L22.0654 22.7462L27.9513 23.6693L28.7262 22.2296L24.7119 17.8299L29.0396 17.6986L31.7243 20.6416L32.9438 19.5322L31.2119 17.6351L34.7985 17.525V17.5208ZM20.6976 13.3413L25.7282 12.2361L22.493 16.242L19.08 16.3436L20.6976 13.3371V13.3413ZM17.3947 7.75598L19.2452 12.5622L17.6276 15.5687L15.8322 12.668L17.3905 7.76022L17.3947 7.75598ZM9.34912 12.7315L14.4348 13.5276L16.2302 16.4283L12.8172 16.5299L9.34488 12.7273L9.34912 12.7315ZM14.6634 21.0862L9.63283 22.1914L12.868 18.1856L16.2768 18.084L14.6592 21.0905L14.6634 21.0862ZM17.9664 26.6716L16.1159 21.8654L17.7335 18.8589L19.5289 21.7595L17.9706 26.6673L17.9664 26.6716ZM26.0119 21.696L20.9263 20.8999L19.1308 17.9993L22.5439 17.8976L26.0162 21.7002L26.0119 21.696Z"
                        fill="#BD0015"
                      />
                    </svg>
                  </Flex>
                  {/* //not fetching anything */}
                  {/* <StructuredTextParser
                    mt="0px"
                    str={render(sectionContent?.[3].body)}
                    {...ProgramFeeSt[lang].feeDiscount1}
                    maxW="auto"
                    color="#1A1D77"
                    fontSize={{ base: '16px', md: '18px' }}
                  /> */}
                </Flex>

                {region == 'in' && lang !== 'en' && isPcPage && (
                  <>
                    <Box
                      borderBottom={{
                        base: '1px solid #6D6358',
                        md: '2px solid #6D6358',
                      }}
                      opacity={0.3}
                      mt="20px"
                    />
                    <Flex
                      flexDir="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <StructuredTextParser
                        str={`${priceData[0]?.curr} ${priceData[0]?.pgmFee}`}
                        maxW="none"
                        textDecoration="line-through"
                        {...ProgramFeeSt[lang].feeDiscount2}
                        color="#6D6358"
                        fontWeight={500}
                      />
                      {discountText?.text && (
                        <Box
                          fontSize={{ base: '26px', md: '30px' }}
                          color="#BD0015"
                          fontFamily="'FedraSansStd-A-medium'"
                          textAlign="center"
                        >
                          {discountText?.text}
                        </Box>
                      )}
                      <Flex
                        fontFamily="'FedraSansStd-book'"
                        flexDir={{ base: 'column', sm: 'row' }}
                      >
                        <StructuredTextParser
                          // mt="25px"
                          str={render(additionalText?.body)?.replace(
                            '#num#',
                            priceData[0]?.coupon.offerValue
                          )}
                          color="#9B7800"
                          fontSize={{ base: '16px', md: '18px' }}
                          fontWeight={600}
                        />
                      </Flex>
                      <Flex alignItems="center">
                        <StructuredTextParser
                          str={`${priceData[0]?.curr} ${priceData[0]?.discountedPrice}`}
                          maxW="none"
                          mt="0px"
                          textDecor="line-through"
                          {...ProgramFeeSt[lang].couponFeeDiscount3}
                          color="#CD9F00"
                        />

                        {/* vernacular languages pricing box details */}
                        <Box
                          ml="10px"
                          fontSize={{ base: '32px', md: '42px' }}
                          color="#CD9F00"
                          fontFamily="'FedraSansStd-A-medium'"
                          {...ProgramFeeSt[lang].couponFee}
                        >
                          {priceData[0]?.curr}{' '}
                          {priceData[0]?.coupon?.postCouponPrice}
                        </Box>
                      </Flex>
                      {priceData.length > 1 && (
                        <>
                          <StructuredTextParser
                            str={render(sectionContent?.[6]?.body)}
                            maxW="none"
                            {...ProgramFeeSt[lang].regionalLanguages}
                            color="#A69786"
                          />
                          <StructuredTextParser
                            // id="program-fee-price"
                            id={`${region}-ver-org-price`}
                            str={`${priceData[1].curr} ${priceData[1].pgmFee}`}
                            textDecoration="line-through"
                            maxW="auto"
                            mt="17px"
                            color="#6D6358"
                            {...ProgramFeeSt[lang].feeDiscount2}
                            fontWeight={500}
                          />

                          <StructuredTextParser
                            fontSize={{ base: '16px', md: '18px' }}
                            fontFamily="'FedraSansStd-book'"
                            flexDir={{ base: 'column', sm: 'row' }}
                            // mt="25px"
                            str={render(
                              additionalTextVernacular?.body
                            )?.replace(
                              '#num#',
                              priceData[0]?.coupon.offerValue
                            )}
                            color="#9B7800"
                          />

                          <Flex alignItems="center">
                            <StructuredTextParser
                              id={`${region}-ver-dis-price`}
                              str={`${priceData[1].curr} ${priceData[1]?.discountedPrice}`}
                              mt="0px"
                              maxW="auto"
                              textDecor="line-through"
                              color="#CD9F00"
                              {...ProgramFeeSt[lang].couponFeeDiscount3}
                            />
                            <Text
                              color="#CD9F00"
                              ml="7px"
                              {...ProgramFeeSt[lang].postCouponPrice}
                            >
                              INR {priceData[1].coupon.postCouponPrice}
                            </Text>
                          </Flex>
                        </>
                      )}
                    </Flex>
                  </>
                )}

                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}

                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                    pb={{ base: '20px', md: '20px' }}
                  >
                    {/* <StructuredTextParser
                      str={`${priceData[0]?.curr} ${priceData[0]?.pgmFee}`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      fontSize={{ base: '24px', md: '26px' }}
                    /> */}
                    <StructuredTextParser
                      // str={`${priceData[0]?.curr} ${priceData[0]?.discountedPrice}`}
                      str={`${priceData[0]?.curr} ${
                        lang === 'id'
                          ? new Intl.NumberFormat('id').format(
                              priceData[0]?.discountedPrice
                            )
                          : priceData[0]?.discountedPrice
                      }`}
                      maxW="none"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      dir={lang == 'ar' ? 'rtl' : 'ltr'}
                      fontSize={{ base: '28px', md: '36px' }}
                    />
                    {discountText?.text && (
                      <Box
                        fontSize={{ base: '26px', md: '32px' }}
                        color="#BD0015"
                        fontFamily="'FedraSansStd-A-medium'"
                        pb="0px"
                        textAlign="center"
                        dir={lang == 'ar' ? 'rtl' : 'ltr'}
                        pt={{ base: '15px', md: '20px' }}
                      >
                        {discountText?.text}
                      </Box>
                    )}
                    {priceData && (
                      <Box
                        fontSize={{ base: '16px', md: '18px' }}
                        fontFamily="'FedraSansStd-book'"
                      >
                        <StructuredTextParser
                          mt="0"
                          str={render(additionalText?.body)
                            ?.replace('#num#', priceData[0]?.coupon?.offerValue)
                            .replace(
                              '##COUPONCODE##',
                              priceData[0]?.coupon?.couponCode
                            )
                            .replace('##CURRENCY##', priceData[0]?.curr)
                            .replace(
                              '##PRICE##',
                              priceData[0]?.coupon?.offerValue
                            )}
                          color="#9B7800"
                          fontFamily="'FedraSansStd-medium'"
                          dir={lang == 'ar' ? 'rtl' : 'ltr'}
                          fontSize={{ base: '16px', md: '18px' }}
                        />
                      </Box>
                    )}
                    <Box
                      fontSize={{ base: '32px', md: '50px' }}
                      color="#1A1D77"
                      fontFamily="'FedraSansStd-A-medium'"
                      lineHeight="46px"
                      pt="15px"
                    >
                      {priceData[0]?.curr}{' '}
                      {/* {priceData[0]?.coupon?.postCouponPrice} */}
                      {lang == 'id' ? (
                        <>
                          {new Intl.NumberFormat('id').format(
                            priceData[0]?.coupon?.postCouponPrice
                          )}
                        </>
                      ) : (
                        <>{priceData[0]?.coupon?.postCouponPrice}</>
                      )}
                    </Box>
                    {/* {!isLandingOrPcPage && ( */} // TODO check the condition
                    later
                    <Flex
                      color="#9B7800"
                      fontFamily="'FedraSansStd-book'"
                      fontWeight="600"
                      paddingLeft="5px"
                    >
                      <StructuredTextParser
                        str={render(sectionContentMap['offer-until']?.body)}
                        color="#9B7800"
                        fontSize="16px"
                        dir={lang == 'ar' ? 'rtl' : 'ltr'}
                        fontFamily="'FedraSansStd-book-i'"
                      />
                    </Flex>
                    {/* )} */}
                  </Flex>
                )}
              </Flex>
            ) : (
              <Flex
                bg="#fff !important"
                flexGrow="1"
                py={{ base: '20px', md: '30px' }}
                px={{ base: '10px', md: '30px', lg: '50px' }}
                flexDir="column"
                maxW={{ base: 'auto', md: '540px' }}
                w="full"
                mx={{ base: 'auto', md: '0' }}
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  gridGap="20px"
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  {lang === 'ar' ? (
                    <>
                      <StructuredTextParser
                        id="program-fee-text"
                        mt="0"
                        str={render(sectionContent?.[3].body)}
                        {...ProgramFeeSt[lang].feeDiscount1}
                        maxW="auto"
                        color="#6D6358"
                      />
                      <Flex>
                        <svg
                          stroke="#be1931"
                          fill="#be1931"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="2.5em"
                          width="2.5em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                        </svg>
                      </Flex>
                    </>
                  ) : (
                    // INFO the heart and offer text section
                    <Box
                      display={'flex'}
                      justifyContent={'center'}
                      gap={{ base: 2, md: 3 }}
                      w={'100%'}
                    >
                      <Flex>
                        <svg
                          stroke="#be1931"
                          fill="#be1931"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="2.5em"
                          width="2.5em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M14 20.408c-.492.308-.903.546-1.192.709-.153.086-.308.17-.463.252h-.002a.75.75 0 0 1-.686 0 16.709 16.709 0 0 1-.465-.252 31.147 31.147 0 0 1-4.803-3.34C3.8 15.572 1 12.331 1 8.513 1 5.052 3.829 2.5 6.736 2.5 9.03 2.5 10.881 3.726 12 5.605 13.12 3.726 14.97 2.5 17.264 2.5 20.17 2.5 23 5.052 23 8.514c0 3.818-2.801 7.06-5.389 9.262A31.146 31.146 0 0 1 14 20.408Z"></path>
                        </svg>
                      </Flex>

                      {/* //Rendering the text ----> **Offered at a reduced fee in our effort to make tools for wellbeing available to all. */}

                      <StructuredTextParser
                        id="program-fee-text"
                        mt="0"
                        str={render(
                          sectionContentMap['program-fee-discount-1']?.body
                        )}
                        {...ProgramFeeSt[lang].feeDiscount1UsInPerson}
                        maxW="auto"
                        color="#6D6358"
                      />
                    </Box>
                  )}
                </Flex>
                {/* Inperson tab fee details */}
                {/* {isInPerson && (
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <StructuredTextParser
                      id={`${region}-${lang}-dis-price`}
                      str={render(
                        sectionContentMap['program-fee-discount-3']?.body
                      )}
                      maxW="none"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                    />{' '}
                  </Box>
                )} */}
                {/* Older Ui code */}
                {!changeUi && (
                  <Box
                    borderBottom={{
                      base: '1px solid #6D6358',
                      md: '2px solid #6D6358',
                    }}
                    opacity={0.3}
                    mt="20px"
                  />
                )}
                {!changeUi && priceData?.length > 0 && (
                  <Flex
                    flexDir="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {/* // the line through text rendering from here */}
                    {!isInPerson && (
                      <>
                        <StructuredTextParser
                          id={`${region}-${lang}-org-price`}
                          str={`${currentSelectedLangPrice.curr} ${
                            lang === 'id'
                              ? new Intl.NumberFormat('id').format(
                                  currentSelectedLangPrice?.pgmFee
                                )
                              : currentSelectedLangPrice?.pgmFee
                          }`}
                          maxW="none"
                          textDecoration="line-through"
                          {...ProgramFeeSt[lang].feeDiscount2}
                          color="#6D6358"
                        />{' '}
                        <StructuredTextParser
                          id={`${region}-${lang}-dis-price`}
                          str={`${currentSelectedLangPrice.curr} ${
                            lang === 'id'
                              ? new Intl.NumberFormat('id').format(
                                  currentSelectedLangPrice?.discountedPrice
                                )
                              : currentSelectedLangPrice?.discountedPrice
                          }`}
                          maxW="none"
                          mt="0px"
                          {...ProgramFeeSt[lang].feeDiscount3}
                          color="#CD9F00"
                        />{' '}
                      </>
                    )}
                    {isInPerson && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <StructuredTextParser
                          id={`${region}-${lang}-org-price`}
                          str={render(sectionContentMap['offer-until']?.body)}
                          maxW="none"
                          // textDecoration="line-through"
                          textAlign={{ base: 'center', md: 'left' }}
                          {...ProgramFeeSt[lang].offerValue}
                          color="#6D6358"
                        />{' '}
                        <SimpleButton
                          // style={sectionContent[sectionContent.length - 2]}
                          style={sectionContentMap['simple_button']}
                          region={region}
                          lang={lang}
                          mx="auto"
                          borderRadius="30px"
                          bgColor="#E86F34"
                          minW="120px"
                          mb="0px"
                          onClick={() => {
                            console.log('button clicked');
                          }}
                        />
                      </Box>
                    )}
                    {/* //TODO the two pricing is not necessary for us ca region ,
                    need clarification */}
                    {/* {priceData?.length > 1 && (
                      <>
                        <StructuredTextParser
                          str={render(sectionContent?.[6]?.body)}
                          maxW="none"
                          {...ProgramFeeSt[lang]?.regionalLanguages}
                          color="#A69786"
                        />
                        <StructuredTextParser
                          // id="program-fee-price"
                          id={`${region}-ver-org-price`}
                          str={`${priceData[1].curr} ${priceData[1]?.pgmFee}`}
                          textDecoration="line-through"
                          maxW="auto"
                          mt="0px"
                          color="#6D6358"
                          {...ProgramFeeSt[lang]?.feeDiscount2}
                        />
                        {!isInPerson && (
                          <StructuredTextParser
                            str={`${priceData[1].curr} ${
                              lang === 'id'
                                ? new Intl.NumberFormat('id').format(
                                    priceData[1]?.discountedPrice
                                  )
                                : priceData[1]?.discountedPrice
                            }`}
                            mt="0px"
                            maxW="auto"
                            color="#CD9F00"
                            {...ProgramFeeSt[lang].feeDiscount3}
                          />
                        )}
                      </>
                    )} */}
                  </Flex>
                )}
                {region === 'us' || region === 'ca' ? (
                  <Box textAlign="center" pt="1.3rem" maxW="372px" mx="auto">
                    {searchByFieldId(sectionContent, 'retake-text') && (
                      <Text
                        as="span"
                        color="#CD9F00"
                        textAlign="center"
                        {...ProgramFeeSt[lang].alreadyCompleted}
                        pr="0"
                      >
                        {searchByFieldId(sectionContent, 'retake-text').text}{' '}
                      </Text>
                    )}
                    {searchByFieldId(sectionContent, 'click-here-link') && (
                      <Link
                        onClick={onOpen}
                        color="#CE6113"
                        fontFamily="'FedraSansStd-book'"
                        textDecor="underline"
                        _hover={{ textDecor: 'none' }}
                        whiteSpace="nowrap"
                      >
                        {
                          searchByFieldId(sectionContent, 'click-here-link')
                            .buttonText
                        }
                      </Link>
                    )}
                  </Box>
                ) : (
                  <Box textAlign="center" pt="1.3rem" maxW="372px" mx="auto">
                    {searchByFieldId(sectionContent, 'retake-info') && (
                      <Text
                        as="span"
                        color="#CD9F00"
                        textAlign="center"
                        {...ProgramFeeSt[lang].alreadyCompleted}
                        pr="5px"
                      >
                        {' '}
                        {searchByFieldId(sectionContent, 'retake-info').text}
                      </Text>
                    )}
                    {searchByFieldId(sectionContent, 'apply-link') && (
                      <Link
                        onClick={onOpen}
                        color="#CE6113"
                        fontFamily="'FedraSansStd-medium'"
                        textDecor="underline"
                        _hover={{ textDecor: 'none' }}
                      >
                        {
                          searchByFieldId(sectionContent, 'apply-link')
                            .buttonText
                        }
                      </Link>
                    )}
                  </Box>
                )}
                {/* // info :- This block block is rendering the scholarship available link */}
                {(region === 'us' || region === 'ca') && (
                  <Flex
                    justifyContent={'center'}
                    alignItems={'center'}
                    w={'100%'}
                    py={4}
                  >
                    {searchByFieldId(sectionContent, 'scholarships-link') && (
                      <NextLink
                        href="#ieo-program-section"
                        passHref
                        legacyBehavior
                      >
                        <Link
                          onClick={() => {
                            scrollTo(scholarshipsRef?.current?.offsetTop, {
                              duration: 500,
                              smooth: true,
                            });
                          }}
                          color="#CE6113"
                          fontFamily="'FedraSansStd-medium'"
                          textDecor="underline"
                          _hover={{ textDecor: 'none' }}
                        >
                          {
                            searchByFieldId(sectionContent, 'scholarships-link')
                              .buttonText
                          }
                        </Link>
                      </NextLink>
                    )}
                  </Flex>
                )}
              </Flex>
            )}
          </Flex>
          {/* //in person tab fee open for ages text */}
          {isInPerson && (
            <Flex
              justifyContent="center"
              textAlign="center"
              width={'full'}
              mx={'auto'}
              pl={{ base: '0', lg: '455px' }}
            >
              <StructuredTextParser
                id={`${region}-${lang}-open-for-ages`}
                str={render(sectionContentMap['open-for-ages']?.body)}
                maxW="none"
                // textDecoration="line-through"
                {...ProgramFeeSt[lang].offerValue}
                color="#fff"
              />{' '}
            </Flex>
          )}

          <Modal isOpen={isOpen} onClose={onClose} size="2xl">
            <ModalOverlay />
            <ModalContent
              bgColor="#F1EBDF"
              borderRadius="0px"
              p={{ base: '1rem 0rem', md: '3.2rem' }}
              maxW={{ base: '90%', md: '670px' }}
            >
              <ModalHeader {...ProgramFeeSt[lang].retakeHeading}>
                {searchByFieldId(sectionContent, 'retake-popup-title') && (
                  <>
                    {searchByFieldId(sectionContent, 'retake-popup-title').text}
                  </>
                )}
              </ModalHeader>
              <ModalCloseButton
                color="#E86F34"
                fontSize="1rem"
                m={{ base: '0rem', md: '1.1rem' }}
              />
              <ModalBody>
                {searchByFieldId(sectionContent, 'popup-text1') && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'popup-text1').body
                    )}
                    mt="0px"
                    {...ProgramFeeSt[lang].retakeTextP}
                    className="textPspacing"
                  />
                )}

                {!changeUi && priceData?.length > 0 && (
                  <>
                    <Box mt={{ base: '30px', md: '30px' }}>
                      {region === 'us' || region === 'ca' ? (
                        <StructuredTextParser
                          str={render(
                            searchByFieldId(
                              sectionContent,
                              'program-fee-discount-popup3'
                            )?.body
                          )}
                          maxW="none"
                          textDecoration="line-through"
                          {...ProgramFeeSt[lang].feeDiscount2}
                          color="#6D6358"
                          textAlign="center"
                        />
                      ) : (
                        <StructuredTextParser
                          str={render(
                            searchByFieldId(
                              sectionContent,
                              'program-fee-discount-popup1'
                            )?.body
                          )}
                          maxW="none"
                          textDecoration="line-through"
                          {...ProgramFeeSt[lang].feeDiscount2}
                          color="#6D6358"
                          textAlign="center"
                        />
                      )}
                    </Box>
                    <StructuredTextParser
                      str={render(
                        searchByFieldId(
                          sectionContent,
                          'program-fee-discount-popup2'
                        )?.body
                      )}
                      maxW="none"
                      mt="0px"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      textAlign="center"
                    />
                  </>
                )}

                {searchByFieldId(sectionContent, 'popup-text2') && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'popup-text2').body
                    )}
                    mt="2rem"
                    {...ProgramFeeSt[lang].retakeTextP}
                  />
                )}
              </ModalBody>

              <ModalFooter>
                {sectionContent[sectionContent.length - 2]._modelApiKey ===
                  'simple_button' && (
                  <SimpleButton
                    style={sectionContent[sectionContent.length - 2]}
                    region={region}
                    lang={lang}
                    mx="auto"
                    borderRadius="30px"
                    bgColor="#E86F34"
                    minW="240px"
                    mb="0px"
                    onClick={() => {
                      onClose();
                    }}
                  />
                )}
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* //no fetching from dato no ui rendering */}
          {sectionContent?.[9]?.table && prgData && (
            <Flex w="full" py={{ base: '30px', md: '80px' }}>
              <TableContainer
                whiteSpace="pre-wrap"
                bg="#fff"
                w="full"
                fontFamily="FedraSansStd-medium"
              >
                <Table variant="striped" colorScheme="blackAlpha">
                  <Thead bg="#B49168">
                    <Tr>
                      {sectionContent?.[9]?.table?.columns?.map(
                        (column, index) => (
                          <Th
                            display={{
                              base:
                                changeUi && index === 1 ? 'none' : 'table-cell',
                              md: 'table-cell',
                            }}
                            key={nanoid()}
                            textAlign="left"
                            {...ProgramFeeSt[lang].tableHead}
                            color="#fff"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            px={{ base: '16px', lg: '50px' }}
                            py={{ base: '15px', md: '30px' }}
                            textTransform="none"
                          >
                            {column}
                          </Th>
                        )
                      )}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {PriceDataList?.map((item, index) => (
                      <Tr key={index}>
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {item['lang'] &&
                            config.lngList[item['lang']?.toLowerCase()]}
                        </Td>
                        {changeUi && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            display={{ base: 'none', md: 'table-cell' }}
                          >
                            <Text
                              as="del"
                              textDecor="line-through"
                              lineHeight={{ base: '26px', xl: 'normal' }}
                              color="#6D6358"
                              {...ProgramFeeSt[lang].bodyTd}
                            >
                              {isIndian && item['curr']} {item['pgmFee']}
                              {/* {item['pgmFee']} */}
                            </Text>
                          </Td>
                        )}
                        <Td
                          px={{ base: '16px', lg: '50px' }}
                          lineHeight={{ base: '26px', xl: 'normal' }}
                          color="#6D6358"
                          {...ProgramFeeSt[lang].bodyTd}
                        >
                          {/* uncomment to add price with discounted price in mobile */}
                          <Text
                            as="del"
                            textDecor="line-through"
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            display={{
                              base: changeUi ? 'auto' : 'none',
                              md: 'none',
                            }}
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            {isIndian && item['curr']} {item['pgmFee']}
                          </Text>
                          <Text>
                            {/* comment the below code to add inr */}
                            {item?.coupon ? (
                              <>
                                {item?.curr} {item?.coupon?.postCouponPrice}
                              </>
                            ) : (
                              <>
                                {isIndian && item['curr']}{' '}
                                {item['discountedPrice']}
                              </>
                            )}
                          </Text>
                        </Td>
                        {sectionContent?.[9]?.table?.columns?.indexOf(' ') !==
                          -1 && (
                          <Td
                            px={{ base: '16px', lg: '50px' }}
                            lineHeight={{ base: '26px', xl: 'normal' }}
                            color="#6D6358"
                            {...ProgramFeeSt[lang].bodyTd}
                          >
                            <NextLink
                              href="#ieo-enroll-section"
                              //href={disabled ? '#' : currentUrl}
                              passHref
                              legacyBehavior
                            >
                              <Link
                                color="#F37021"
                                display="flex"
                                _hover={{ color: '#BC570F' }}
                                onClick={() => {
                                  // console.log('Called onClick', item.lang);
                                  setProgramLanguage(item.lang);
                                  gtmClick(item.lang, item['discountedPrice']);
                                }}
                              >
                                Register Now
                                {/* <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M9 20.5L17 12.5L9 4.5" stroke="#F37021" strokeWidth="2.66667" />
                                </svg> */}
                              </Link>
                            </NextLink>
                          </Td>
                        )}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Flex>
          )}
        </Flex>
        <style global>
          {`
            .thanksgiving:hover svg {
              fill: #E86F34;
              color: #E86F34;
            }
            .thanksgiving:hover {
              background: '#FAE4B8';
              color: '#FFFFFF';
            }
            .textPspacing p:last-child{
              padding-top:25px
            }
              `}
        </style>
      </Flex>
    </Box>
  );
};

export default ProgramFee;
